import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { queryParser } from '@applyft-web/utils';
import { selectEventsData } from '../store/events';

export const useUtmTerm = (): string | undefined => {
  const location = useLocation();
  const eventsData = useSelector(selectEventsData);

  return useMemo(() => {
    const fromStore = eventsData?.utm?.utm_term;
    const queryParams = queryParser(location.search) as Record<string, string | undefined>;
    const fromQuery = queryParams.utm_term;
    const raw = fromStore ?? fromQuery;
    return typeof raw === 'string' ? raw.replaceAll('+', ' ') : undefined;
  }, [eventsData, location.search]);
};
